import * as React from 'react'
import clx from 'classnames'
import { Item } from '../../mtt-ttmzero-cover/js/Item'
import { useNetdaniaData } from '../../mtt-ttmzero-cover/js/useNetdaniaData'

export function GraphSliderTextItems(props) {
  let instruments = props.items.map(i => ({
    symbol: i.instrument_symbol,
    provider: i.instrument_provider,
  }))
  const [value, requests] = useNetdaniaData(instruments, 400)
  return (
    <section
      className={clx('mtt-graph-slider' + props.cls)}
      data-duration={props.duration}
      style={{ '--duration': props.duration + 'ms' }}
    >
      <div className="mtt-graph-slider__inner">
        <div className="mtt-graph-slider__bg" />
        <div className="mtt-graph-slider__wrap">
          <div className="mtt-graph-slider__items-wrap">
            {requests.map(({ i, s }) => {
              if (value?.[i] == null) {
                return null
              }
              return <Item v={value[i]} key={i} i={i} symbol={s} />
            })}
          </div>
          <div className="mtt-graph-slider__items-wrap second-wrap">
            {requests.map(({ i, s }) => {
              if (value?.[i] == null) {
                return null
              }
              return <Item v={value[i]} key={i} i={i} symbol={s} />
            })}
          </div>
        </div>
        <div className="mtt-graph-slider__bg mtt-graph-slider__bg--bottom" />
      </div>
    </section>
  )
}
